__turbopack_context__.v({
  "sentinel": "StickyFilterBarRow-module-scss-module__hcSr0W__sentinel",
  "sticky": "StickyFilterBarRow-module-scss-module__hcSr0W__sticky",
  "stuck": "StickyFilterBarRow-module-scss-module__hcSr0W__stuck",
});
